import { Box, Typography } from '@mui/material'
import { type RcnOperationsSummary } from '../../../../models/BudgetSummary'

interface Props {
  rcnOperationsSummary: RcnOperationsSummary
}
export const RcnOperationsBudgetDisplay = (props: Props): JSX.Element => {
  // const cardStyles = {
  //   mt: '1em',
  //   bgcolor: 'var(--grey-100)',
  //   borderRadius: '16px',
  //   py: '10px',
  //   px: '24px',
  //   display: 'flex',
  //   justifyContent: 'space-between'
  // }

  return <Box sx={{ borderBottom: '1px solid var(--grey-300)' }}>
    <Typography variant='h5' sx={{ mt: '1em' }}>
      RCN Operations
    </Typography>

    <Typography variant='body1'>
      Budget requests
    </Typography>

    {/* <Box sx={cardStyles}> */}
    {/*  <Typography variant='h4'> */}
    {/*    Meeting Schedules */}
    {/*  </Typography> */}

    {/*  <Typography variant='body1' sx={{ textAlign: 'right', fontSize: '16px' }}> */}
    {/*    {props.rcnOperationsSummary.meetingSchedules.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })} */}
    {/*  </Typography> */}
    {/* </Box> */}

    {/* <Box sx={cardStyles}> */}
    {/*  <Typography variant='h4'> */}
    {/*    Support Costs */}
    {/*  </Typography> */}

    {/*  <Typography variant='body1' sx={{ textAlign: 'right', fontSize: '16px' }}> */}
    {/*    {props.rcnOperationsSummary.supportCost.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })} */}
    {/*  </Typography> */}
    {/* </Box> */}

    <Typography variant='h5' sx={{ textAlign: 'right', mt: '1em', mr: '24px' }}>
      Total: {props.rcnOperationsSummary.totalAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
    </Typography>
  </Box>
}
